enum EditionAsap {
  AVIS_SAP_EDITER = '01',
  AVIS_SAP_CPP = '02',
  AVIS_SAP_ORMC_CPP_PDF = '03',
  AVIS_SAP_SANS_TRAIT_DGFIP = '04',
  AVIS_SAP_PATIENT_A_EDITER = '05',
  AVIS_SAP_ORMC_ENSU_A_EDITER_PDF = '06',
  AVIS_SAP_ORMC_ENSU_A_EDITER_XML = '07',
  AVIS_SAP_ORMC_CPP_XML = '08',
}

export default EditionAsap;
